const WizardControllers = ({
  steps,
  prevStep,
  nextStep,
  currentStep,
  children,
  canContinue,
}) => {
  return (
    <div className="mt-2">
      {/* Progress Indicator */}
      <div className="w-full px-4 sm:px-8 mb-6">
        {/* Step Counter */}
        <div className="text-center mb-3">
          <p className="text-sm text-gray-600">
            Paso <span className="font-semibold text-blue-600">{currentStep + 1}</span> de{" "}
            <span className="font-semibold">{steps.length}</span>
          </p>
        </div>

        {/* Progress Dots with Labels */}
        <div className="flex items-start justify-center">
          <ol className="flex items-start space-x-4 sm:space-x-8">
            {steps.map((step, i) => (
              <li key={`step_${i}`} className="flex flex-col items-center">
                {/* Dot */}
                <div className="relative flex items-center justify-center mb-2">
                  {step.status === "complete" ? (
                    <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                    </div>
                  ) : step.status === "current" ? (
                    <div className="relative flex items-center justify-center">
                      <span className="absolute w-10 h-10 bg-blue-200 rounded-full animate-pulse" />
                      <span className="relative w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
                        {i + 1}
                      </span>
                    </div>
                  ) : (
                    <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center text-gray-600 font-semibold text-sm">
                      {i + 1}
                    </div>
                  )}
                </div>

                {/* Label - Hidden on mobile for better spacing */}
                <span className={`hidden sm:block text-xs text-center max-w-[80px] ${
                  step.status === "current" ? "font-semibold text-blue-600" : "text-gray-600"
                }`}>
                  {step.name}
                </span>
              </li>
            ))}
          </ol>
        </div>

        {/* Current Step Name (Mobile) */}
        <div className="sm:hidden text-center mt-3">
          <p className="text-sm font-semibold text-gray-800">
            {steps[currentStep]?.name}
          </p>
        </div>
      </div>

      {/* Content Area */}
      <div className="h-[55vh] sm:h-[60vh] overflow-y-auto px-2">{children}</div>

      {/* Navigation Buttons */}
      <div className="flex items-center justify-between px-4 sm:px-8 mt-4 pb-2">
        <button
          type="button"
          disabled={currentStep === 0}
          onClick={() => prevStep()}
          className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all ${
            currentStep === 0
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-gray-500 text-white hover:bg-gray-600 active:scale-95"
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
            />
          </svg>
          <span className="hidden sm:inline">Anterior</span>
        </button>

        {/* Continue Button - Only visible when form is valid */}
        {canContinue && currentStep < steps.length - 1 && (
          <button
            type="button"
            onClick={() => nextStep()}
            className="flex items-center space-x-2 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 active:scale-95 transition-all shadow-md"
          >
            <span>Continuar</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
              className="w-5 h-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
              />
            </svg>
          </button>
        )}

        {/* Placeholder for layout balance when no continue button */}
        {(!canContinue || currentStep >= steps.length - 1) && (
          <div className="w-24"></div>
        )}
      </div>

      {/* Helper Text */}
      {!canContinue && (
        <div className="text-center mt-2">
          <p className="text-xs text-gray-500">
            Completá todos los campos requeridos para continuar
          </p>
        </div>
      )}
    </div>
  );
};

export default WizardControllers;
